module.exports = __webpack_public_path__ + "img/collection-engagementRingsCollectionRings@2x.1d3bad0.jpg";